{
  "about.blocks": "Server yang dimoderasi",
  "about.contact": "Kontak:",
  "about.default_locale": "Default",
  "about.disclaimer": "Mastodon adalah perangkat lunak bebas dan sumber terbuka, serta merek dagang milik Mastodon gGmbH.",
  "about.domain_blocks.no_reason_available": "Alasan tidak tersedia",
  "about.domain_blocks.preamble": "Mastodon umumnya mengizinkan Anda untuk melihat konten dan berinteraksi dengan pengguna dari server lain di fediverse. Ini adalah pengecualian yang dibuat untuk beberapa server.",
  "about.domain_blocks.silenced.explanation": "Anda secara umum tidak melihat profil dan konten dari server ini, kecuali jika Anda mencarinya atau memilihnya dengan mengikuti secara eksplisit.",
  "about.domain_blocks.silenced.title": "Terbatas",
  "about.domain_blocks.suspended.explanation": "Tidak ada data yang diproses, disimpan, atau ditukarkan dari server ini, membuat interaksi atau komunikasi dengan pengguna dari server ini tidak mungkin dilakukan.",
  "about.domain_blocks.suspended.title": "Ditangguhkan",
  "about.language_label": "Bahasa",
  "about.not_available": "Informasi ini belum tersedia di server ini.",
  "about.powered_by": "Media sosial terdesentralisasi diberdayakan oleh {mastodon}",
  "about.rules": "Aturan server",
  "account.account_note_header": "Personal note",
  "account.add_or_remove_from_list": "Tambah atau Hapus dari daftar",
  "account.badges.bot": "Bot",
  "account.badges.group": "Grup",
  "account.block": "Blokir @{name}",
  "account.block_domain": "Blokir domain {domain}",
  "account.block_short": "Blokir",
  "account.blocked": "Terblokir",
  "account.cancel_follow_request": "Batalkan permintaan ikut",
  "account.copy": "Salin tautan ke profil",
  "account.direct": "Sebut secara pribadi @{name}",
  "account.disable_notifications": "Berhenti memberitahu saya ketika @{name} memposting",
  "account.edit_profile": "Ubah profil",
  "account.enable_notifications": "Beritahu saya saat @{name} memposting",
  "account.endorse": "Tampilkan di profil",
  "account.familiar_followers_one": "Diikuti oleh {name1}",
  "account.familiar_followers_two": "Diikuti oleh {name1} dan {name2}",
  "account.featured": "Unggulan",
  "account.featured.accounts": "Profil",
  "account.follow": "Ikuti",
  "account.follow_back": "Ikuti balik",
  "account.followers": "Pengikut",
  "account.followers.empty": "Pengguna ini belum ada pengikut.",
  "account.followers_counter": "{count, plural, other {{counter} followers}}",
  "account.following": "Mengikuti",
  "account.following_counter": "{count, plural, other {{counter} following}}",
  "account.follows.empty": "Pengguna ini belum mengikuti siapa pun.",
  "account.follows_you": "Mengikuti Anda",
  "account.go_to_profile": "Buka profil",
  "account.hide_reblogs": "Sembunyikan boosts dari @{name}",
  "account.in_memoriam": "Mengenang.",
  "account.joined_short": "Bergabung",
  "account.languages": "Ubah langganan bahasa",
  "account.link_verified_on": "Kepemilikan tautan ini telah dicek pada {date}",
  "account.locked_info": "Status privasi akun ini disetel untuk dikunci. Pemilik secara manual meninjau siapa yang dapat mengikutinya.",
  "account.media": "Media",
  "account.mention": "Balasan @{name}",
  "account.moved_to": "{name} mengabarkan bahwa akun baru mereka kini adalah:",
  "account.mute": "Bisukan @{name}",
  "account.mute_notifications_short": "Senyapkan Notifikasi",
  "account.mute_short": "Senyapkan",
  "account.muted": "Dibisukan",
  "account.no_bio": "Tidak ada deskripsi yang diberikan.",
  "account.open_original_page": "Buka halaman asli",
  "account.posts": "Kiriman",
  "account.report": "Laporkan @{name}",
  "account.requested_follow": "{name} ingin mengikuti Anda",
  "account.share": "Bagikan profil @{name}",
  "account.show_reblogs": "Tampilkan boost dari @{name}",
  "account.statuses_counter": "{count, plural, other {{counter} posts}}",
  "account.unblock": "Buka blokir @{name}",
  "account.unblock_domain": "Buka blokir domain {domain}",
  "account.unblock_short": "Buka blokir",
  "account.unendorse": "Jangan tampilkan di profil",
  "account.unfollow": "Berhenti mengikuti",
  "account.unmute": "Berhenti membisukan @{name}",
  "account.unmute_notifications_short": "Tampilkan notifikasi",
  "account.unmute_short": "Bunyikan",
  "account_note.placeholder": "Klik untuk menambah catatan",
  "admin.dashboard.daily_retention": "Tingkat retensi pengguna perhari setelah mendaftar",
  "admin.dashboard.monthly_retention": "Tingkat retensi pengguna perbulan setelah mendaftar",
  "admin.dashboard.retention.average": "Rata-rata",
  "admin.dashboard.retention.cohort": "Bulan pendaftaran",
  "admin.dashboard.retention.cohort_size": "Pengguna baru",
  "admin.impact_report.instance_accounts": "Akun profil yang akan terhapus",
  "admin.impact_report.instance_followers": "Pengikut yang akan kehilangan oleh pengguna kita",
  "admin.impact_report.instance_follows": "Pengikut yang akan kehilangan oleh pengguna lain",
  "admin.impact_report.title": "Ringkasan dampak",
  "alert.rate_limited.message": "Mohon ulangi setelah {retry_time, time, medium}.",
  "alert.rate_limited.title": "Jumlah akses dibatasi",
  "alert.unexpected.message": "Terjadi kesalahan yang tidak terduga.",
  "alert.unexpected.title": "Ups!",
  "alt_text_badge.title": "Teks Alternatif",
  "announcement.announcement": "Pengumuman",
  "attachments_list.unprocessed": "(tidak diproses)",
  "audio.hide": "Sembunyikan audio",
  "block_modal.remote_users_caveat": "Kami akan meminta {domain} server untuk menghargai keputusan Anda. Namun, kepatuhan tak dapat dipastikan karena beberapa server dapat menangani blokir secara beragam. Postingan publik masih dapat terlihat oleh pengguna tanpa masuk.",
  "block_modal.show_less": "Tampilkan lebih sedikit",
  "block_modal.show_more": "Tampilkan lebih banyak",
  "block_modal.they_will_know": "Mereka dapat melihat bahwa mereka diblokir.",
  "block_modal.title": "Blokir pengguna?",
  "boost_modal.combo": "Anda dapat menekan {combo} untuk melewati ini",
  "boost_modal.reblog": "Pacu kiriman?",
  "boost_modal.undo_reblog": "Jangan pacu kiriman?",
  "bundle_column_error.copy_stacktrace": "Salin laporan kesalahan",
  "bundle_column_error.error.body": "Laman yang diminta tidak dapat ditampilkan. Mungkin karena sebuah kutu dalam kode kami, atau masalah kompatibilitas peramban.",
  "bundle_column_error.error.title": "Oh, tidak!",
  "bundle_column_error.network.body": "Ada kesalahan ketika memuat laman ini. Ini dapat terjadi karena masalah sementara dengan koneksi internet Anda atau server ini.",
  "bundle_column_error.network.title": "Kesalahan jaringan",
  "bundle_column_error.retry": "Coba lagi",
  "bundle_column_error.return": "Kembali ke beranda",
  "bundle_column_error.routing.body": "Laman yang diminta tidak ditemukan. Apakah Anda yakin bahwa URL dalam bilah alamat benar?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Tutup",
  "bundle_modal_error.retry": "Coba lagi",
  "closed_registrations.other_server_instructions": "Karena Mastodon itu terdesentralisasi, Anda dapat membuat sebuah akun di server lain dan masih dapat berinteraksi dengan satu ini.",
  "closed_registrations_modal.description": "Membuat sebuah akun di {domain} saat ini tidak memungkinkan, tetapi diingat bahwa Anda tidak harus memiliki sebuah akun secara khusus di {domain} untuk menggunakan Mastodon.",
  "closed_registrations_modal.find_another_server": "Cari server lain",
  "closed_registrations_modal.preamble": "Mastodon itu terdesentralisasi, jadi di mana pun Anda buat akun, Anda masih akan dapat mengikuti dan berinteraksi dengan siapa pun di server ini. Anda bahkan dapat host Mastodon sendiri!",
  "closed_registrations_modal.title": "Mendaftar di Mastodon",
  "column.about": "Tentang",
  "column.blocks": "Pengguna yang diblokir",
  "column.bookmarks": "Markah",
  "column.community": "Linimasa Lokal",
  "column.direct": "Sebut secara pribadi",
  "column.directory": "Jelajahi profil",
  "column.domain_blocks": "Domain tersembunyi",
  "column.favourites": "Favorit",
  "column.firehose": "Umpan terkini",
  "column.follow_requests": "Permintaan mengikuti",
  "column.home": "Beranda",
  "column.lists": "List",
  "column.mutes": "Pengguna yang dibisukan",
  "column.notifications": "Notifikasi",
  "column.pins": "Kiriman tersemat",
  "column.public": "Linimasa gabungan",
  "column_back_button.label": "Kembali",
  "column_header.hide_settings": "Sembunyikan pengaturan",
  "column_header.moveLeft_settings": "Pindahkan kolom ke kiri",
  "column_header.moveRight_settings": "Pindahkan kolom ke kanan",
  "column_header.pin": "Sematkan",
  "column_header.show_settings": "Tampilkan pengaturan",
  "column_header.unpin": "Lepaskan",
  "community.column_settings.local_only": "Hanya lokal",
  "community.column_settings.media_only": "Hanya media",
  "community.column_settings.remote_only": "Hanya jarak jauh",
  "compose.language.change": "Ganti bahasa",
  "compose.language.search": "Telusuri bahasa...",
  "compose.published.body": "Postingan diterbitkan.",
  "compose.published.open": "Buka",
  "compose.saved.body": "Postingan tersimpan.",
  "compose_form.direct_message_warning_learn_more": "Pelajari lebih lanjut",
  "compose_form.encryption_warning": "Kiriman di Mastodon tidak dienkripsi secara end-to-end. Jangan bagikan informasi sensitif melalui Mastodon.",
  "compose_form.hashtag_warning": "Kiriman ini tidak akan didaftarkan di bawah tagar apapun selama tidak diatur ke publik. Hanya kiriman publik yang dapat dicari dengan tagar.",
  "compose_form.lock_disclaimer": "Akun Anda tidak {locked}. Semua orang dapat mengikuti Anda untuk melihat kiriman khusus untuk pengikut Anda.",
  "compose_form.lock_disclaimer.lock": "terkunci",
  "compose_form.placeholder": "Apa yang ada di pikiran Anda?",
  "compose_form.poll.duration": "Durasi japat",
  "compose_form.poll.multiple": "Pilihan ganda",
  "compose_form.poll.option_placeholder": "Opsi {number}",
  "compose_form.poll.single": "Pilihan tunggal",
  "compose_form.poll.switch_to_multiple": "Ubah japat menjadi pilihan ganda",
  "compose_form.poll.switch_to_single": "Ubah japat menjadi pilihan tunggal",
  "compose_form.poll.type": "Gaya",
  "compose_form.publish": "Postingan",
  "compose_form.reply": "Balas",
  "compose_form.save_changes": "Perbarui",
  "compose_form.spoiler.marked": "Hapus peringatan tentang isi konten",
  "compose_form.spoiler.unmarked": "Tambahkan peringatan tentang isi konten",
  "compose_form.spoiler_placeholder": "Peringatan konten (opsional)",
  "confirmation_modal.cancel": "Batal",
  "confirmations.block.confirm": "Blokir",
  "confirmations.delete.confirm": "Hapus",
  "confirmations.delete.message": "Apakah Anda yakin untuk menghapus kiriman ini?",
  "confirmations.delete.title": "Delete post?",
  "confirmations.delete_list.confirm": "Hapus",
  "confirmations.delete_list.message": "Apakah Anda yakin untuk menghapus daftar ini secara permanen?",
  "confirmations.delete_list.title": "Delete list?",
  "confirmations.discard_edit_media.confirm": "Buang",
  "confirmations.discard_edit_media.message": "Anda belum menyimpan perubahan deskripsi atau pratinjau media, buang saja?",
  "confirmations.logout.confirm": "Keluar",
  "confirmations.logout.message": "Apakah Anda yakin ingin keluar?",
  "confirmations.logout.title": "Log out?",
  "confirmations.mute.confirm": "Bisukan",
  "confirmations.redraft.confirm": "Hapus dan susun ulang",
  "confirmations.redraft.message": "Apakah anda yakin ingin menghapus postingan ini dan menyusun ulang postingan ini? Favorit dan peningkatan akan hilang, dan balasan ke postingan asli tidak akan terhubung ke postingan manapun.",
  "confirmations.redraft.title": "Delete & redraft post?",
  "confirmations.unfollow.confirm": "Berhenti mengikuti",
  "content_warning.hide": "Hide post",
  "content_warning.show": "Show anyway",
  "conversation.delete": "Hapus percakapan",
  "conversation.mark_as_read": "Tandai sudah dibaca",
  "conversation.open": "Lihat percakapan",
  "conversation.with": "Dengan {names}",
  "copy_icon_button.copied": "Disalin ke clipboard",
  "copypaste.copied": "Disalin",
  "copypaste.copy_to_clipboard": "Salin ke clipboard",
  "directory.federated": "Dari fediverse yang dikenal",
  "directory.local": "Dari {domain} saja",
  "directory.new_arrivals": "Yang baru datang",
  "directory.recently_active": "Baru-baru ini aktif",
  "disabled_account_banner.account_settings": "Pengaturan akun",
  "disabled_account_banner.text": "Akun {disabledAccount} Anda kini dinonaktifkan.",
  "dismissable_banner.community_timeline": "Ini adalah kiriman publik terkini dari orang yang akunnya berada di {domain}.",
  "dismissable_banner.dismiss": "Abaikan",
  "domain_block_modal.block": "Blokir server",
  "domain_block_modal.block_account_instead": "Blokir @{name} saja",
  "domain_block_modal.they_can_interact_with_old_posts": "Orang-orang dari server ini dapat berinteraksi dengan kiriman lama anda.",
  "domain_block_modal.they_cant_follow": "Tidak ada seorangpun dari server ini yang dapat mengikuti anda.",
  "domain_block_modal.they_wont_know": "Mereka tidak akan tahu bahwa mereka diblokir.",
  "domain_block_modal.title": "Blokir domain?",
  "domain_block_modal.you_will_lose_relationships": "Kamu akan kehilangan semua pengikut dan orang yang kamu ikuti dari server ini.",
  "domain_block_modal.you_wont_see_posts": "Anda tidak akan melihat postingan atau notifikasi dari pengguna di server ini.",
  "domain_pill.activitypub_lets_connect": "Ini memungkinkan anda terhubung dan berinteraksi dengan orang-orang tidak hanya di Mastodon, tetapi juga di berbagai aplikasi sosial.",
  "domain_pill.activitypub_like_language": "ActivityPub seperti bahasa yang digunakan Mastodon dengan jejaring sosial lainnya.",
  "domain_pill.server": "Server",
  "domain_pill.their_handle": "Nama penggunanya:",
  "domain_pill.their_server": "Rumah digital mereka, di mana semua postingan mereka tersedia.",
  "domain_pill.their_username": "Pengenal unik mereka di server tersebut. Itu memungkinkan dapat mencari pengguna dengan nama yang sama di server lain.",
  "domain_pill.username": "Nama pengguna",
  "domain_pill.whats_in_a_handle": "Apa itu nama pengguna?",
  "domain_pill.who_they_are": "Karena nama pengguna menunjukkan siapa seseorang dan di mana server mereka berada, anda dapat berinteraksi dengan orang-orang di seluruh web sosial  <button>ActivityPub-powered platforms</button>.",
  "domain_pill.who_you_are": "<button>ActivityPub-powered platforms</button>.",
  "domain_pill.your_handle": "Nama pengguna anda:",
  "domain_pill.your_server": "Your digital home, where all of your posts live. Don’t like this one? Transfer servers at any time and bring your followers, too.",
  "domain_pill.your_username": "Pengenal unik anda di server ini. Itu memungkinkan dapat mencari pengguna dengan nama yang sama di server lain.",
  "embed.instructions": "Sematkan kiriman ini di situs web Anda dengan menyalin kode di bawah ini.",
  "embed.preview": "Tampilan akan seperti ini nantinya:",
  "emoji_button.activity": "Aktivitas",
  "emoji_button.clear": "Hapus",
  "emoji_button.custom": "Kustom",
  "emoji_button.flags": "Bendera",
  "emoji_button.food": "Makanan & Minuman",
  "emoji_button.label": "Tambahkan emoji",
  "emoji_button.nature": "Alam",
  "emoji_button.not_found": "Katakan tidak pada emoji!! (╯°□°）╯︵ ┻━┻",
  "emoji_button.objects": "Benda-benda",
  "emoji_button.people": "Orang",
  "emoji_button.recent": "Yang sering digunakan",
  "emoji_button.search": "Cari...",
  "emoji_button.search_results": "Hasil pencarian",
  "emoji_button.symbols": "Simbol",
  "emoji_button.travel": "Tempat Wisata",
  "empty_column.account_suspended": "Akun ditangguhkan",
  "empty_column.account_timeline": "Tidak ada toot di sini!",
  "empty_column.account_unavailable": "Profil tidak tersedia",
  "empty_column.blocks": "Anda belum memblokir siapa pun.",
  "empty_column.bookmarked_statuses": "Anda belum memiliki kiriman termarkah. Saat Anda menandainya sebagai markah, mereka akan muncul di sini.",
  "empty_column.community": "Linimasa lokal masih kosong. Tulis sesuatu secara publik dan buat roda berputar!",
  "empty_column.domain_blocks": "Tidak ada topik tersembunyi.",
  "empty_column.explore_statuses": "Tidak ada yang sedang tren pada saat ini. Periksa lagi nanti!",
  "empty_column.follow_requests": "Anda belum memiliki permintaan mengikuti. Ketika Anda menerimanya, maka itu akan muncul di sini.",
  "empty_column.followed_tags": "Anda belum mengikuti tagar apapun. Saat Anda mulai melakukannya, mereka akan muncul di sini.",
  "empty_column.hashtag": "Tidak ada apa pun dalam hashtag ini.",
  "empty_column.home": "Linimasa anda kosong! Kunjungi {public} atau gunakan pencarian untuk memulai dan bertemu pengguna lain.",
  "empty_column.list": "Belum ada apa pun di daftar ini. Ketika anggota dari daftar ini mengirim kiriman baru, mereka akan tampil di sini.",
  "empty_column.mutes": "Anda belum membisukan siapa pun.",
  "empty_column.notifications": "Anda belum memiliki notifikasi. Ketika orang lain berinteraksi dengan Anda, Anda akan melihatnya di sini.",
  "empty_column.public": "Tidak ada apa pun di sini! Tulis sesuatu, atau ikuti pengguna lain dari server lain untuk mengisi ini",
  "error.unexpected_crash.explanation": "Karena kutu pada kode kami atau isu kompatibilitas peramban, halaman tak dapat ditampilkan dengan benar.",
  "error.unexpected_crash.explanation_addons": "Halaman ini tidak dapat ditampilkan dengan benar. Kesalahan ini mungkin disebabkan pengaya peramban atau alat terjemahan otomatis.",
  "error.unexpected_crash.next_steps": "Coba segarkan halaman. Jika itu tidak membantu, Anda masih bisa memakai Mastodon dengan peramban berbeda atau aplikasi asli.",
  "error.unexpected_crash.next_steps_addons": "Coba nonaktifkan mereka lalu segarkan halaman. Jika itu tidak membantu, Anda masih bisa memakai Mastodon dengan peramban berbeda atau aplikasi asli.",
  "errors.unexpected_crash.copy_stacktrace": "Salin stacktrace ke papan klip",
  "errors.unexpected_crash.report_issue": "Laporkan masalah",
  "explore.suggested_follows": "Orang",
  "explore.trending_links": "Berita",
  "explore.trending_statuses": "Kiriman",
  "explore.trending_tags": "Tagar",
  "filter_modal.added.context_mismatch_explanation": "Kategori filter ini tidak berlaku untuk konteks di mana Anda mengakses postingan ini. Jika Anda ingin postingan tersebut difilter juga dalam konteks ini, Anda perlu mengedit filter.",
  "filter_modal.added.context_mismatch_title": "Konteks tidak cocok!",
  "filter_modal.added.expired_explanation": "Kategori saringan ini telah kedaluwarsa, Anda harus mengubah tanggal kedaluwarsa untuk diterapkan.",
  "filter_modal.added.expired_title": "Saringan kedaluwarsa!",
  "filter_modal.added.review_and_configure": "Untuk meninjau dan mengatur kategori saringan ini lebih jauh, pergi ke {settings_link}.",
  "filter_modal.added.review_and_configure_title": "Pengaturan saringan",
  "filter_modal.added.settings_link": "laman pengaturan",
  "filter_modal.added.short_explanation": "Kiriman ini telah ditambahkan ke kategori saringan berikut: {title}.",
  "filter_modal.added.title": "Saringan ditambahkan!",
  "filter_modal.select_filter.context_mismatch": "tidak diterapkan ke konteks ini",
  "filter_modal.select_filter.expired": "kedaluwarsa",
  "filter_modal.select_filter.prompt_new": "Kategori baru: {name}",
  "filter_modal.select_filter.search": "Cari atau buat",
  "filter_modal.select_filter.subtitle": "Gunakan kategori yang sudah ada atau buat yang baru",
  "filter_modal.select_filter.title": "Saring kiriman ini",
  "filter_modal.title.status": "Saring sebuah kiriman",
  "filtered_notifications_banner.title": "Notifikasi yang disaring",
  "firehose.all": "Semua",
  "firehose.local": "Server Ini",
  "firehose.remote": "Server Lain",
  "follow_request.authorize": "Izinkan",
  "follow_request.reject": "Tolak",
  "follow_requests.unlocked_explanation": "Meskipun akun Anda tidak dikunci, staf {domain} menyarankan Anda untuk meninjau permintaan mengikuti dari akun-akun ini secara manual.",
  "follow_suggestions.curated_suggestion": "Pilihan staf",
  "follow_suggestions.dismiss": "Jangan tampilkan lagi",
  "follow_suggestions.friends_of_friends_longer": "Populer di antara orang yang anda ikuti",
  "follow_suggestions.hints.featured": "Profil ini telah dipilih sendiri oleh tim {domain}.",
  "follow_suggestions.hints.friends_of_friends": "Profil ini populer di kalangan orang yang anda ikuti.",
  "follow_suggestions.personalized_suggestion": "Saran yang dipersonalisasi",
  "follow_suggestions.popular_suggestion": "Saran populer",
  "follow_suggestions.popular_suggestion_longer": "Populer di {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "Serupa dengan profil yang baru Anda ikuti",
  "follow_suggestions.view_all": "Lihat semua",
  "follow_suggestions.who_to_follow": "Siapa yang harus diikuti",
  "followed_tags": "Tagar yang diikuti",
  "footer.about": "Tentang",
  "footer.directory": "Direktori profil",
  "footer.get_app": "Dapatkan aplikasi",
  "footer.keyboard_shortcuts": "Pintasan papan ketik",
  "footer.privacy_policy": "Kebijakan privasi",
  "footer.source_code": "Lihat kode sumber",
  "footer.status": "Status",
  "generic.saved": "Disimpan",
  "getting_started.heading": "Mulai",
  "hashtag.column_header.tag_mode.all": "dan {additional}",
  "hashtag.column_header.tag_mode.any": "atau {additional}",
  "hashtag.column_header.tag_mode.none": "tanpa {additional}",
  "hashtag.column_settings.select.no_options_message": "Tidak ada saran yang ditemukan",
  "hashtag.column_settings.select.placeholder": "Masukkan tagar…",
  "hashtag.column_settings.tag_mode.all": "Semua ini",
  "hashtag.column_settings.tag_mode.any": "Semua ini",
  "hashtag.column_settings.tag_mode.none": "Tak satu pun",
  "hashtag.column_settings.tag_toggle": "Include additional tags in this column",
  "hashtag.follow": "Ikuti tagar",
  "hashtag.unfollow": "Batalkan pengikutan tagar",
  "home.column_settings.show_reblogs": "Tampilkan boost",
  "home.column_settings.show_replies": "Tampilkan balasan",
  "home.hide_announcements": "Sembunyikan pengumuman",
  "home.pending_critical_update.link": "Lihat pembaruan",
  "home.show_announcements": "Tampilkan pengumuman",
  "interaction_modal.on_another_server": "Di server lain",
  "interaction_modal.on_this_server": "Di server ini",
  "intervals.full.days": "{number, plural, other {# hari}}",
  "intervals.full.hours": "{number, plural, other {# jam}}",
  "intervals.full.minutes": "{number, plural, other {# menit}}",
  "keyboard_shortcuts.back": "Kembali ke belakang",
  "keyboard_shortcuts.blocked": "Buka daftar pengguna yang diblokir",
  "keyboard_shortcuts.boost": "Tingkatkan postingan",
  "keyboard_shortcuts.column": "Fokus kolom",
  "keyboard_shortcuts.compose": "Fokus pada kotak teks",
  "keyboard_shortcuts.description": "Deskripsi",
  "keyboard_shortcuts.down": "Pindah ke bawah dalam daftar",
  "keyboard_shortcuts.enter": "Buka kiriman",
  "keyboard_shortcuts.federated": "Buka linimasa terpadu",
  "keyboard_shortcuts.heading": "Pintasan keyboard",
  "keyboard_shortcuts.home": "Buka linimasa beranda",
  "keyboard_shortcuts.hotkey": "Pintasan",
  "keyboard_shortcuts.legend": "Tampilkan legenda ini",
  "keyboard_shortcuts.local": "Buka linimasa lokal",
  "keyboard_shortcuts.mention": "Sebutkan penulis",
  "keyboard_shortcuts.muted": "Buka daftar pengguna yang dibisukan",
  "keyboard_shortcuts.my_profile": "Buka profil Anda",
  "keyboard_shortcuts.notifications": "Buka kolom pemberitahuan",
  "keyboard_shortcuts.open_media": "Buka media",
  "keyboard_shortcuts.pinned": "buka daftar toot tersemat",
  "keyboard_shortcuts.profile": "Buka profil penulis",
  "keyboard_shortcuts.reply": "Balas posting",
  "keyboard_shortcuts.requests": "Buka daftar permintaan mengikuti",
  "keyboard_shortcuts.search": "Fokus ke kotak pencarian",
  "keyboard_shortcuts.spoilers": "Tampilkan/sembunyikan bidang CW",
  "keyboard_shortcuts.start": "Buka kolom “Mulai”",
  "keyboard_shortcuts.toggle_hidden": "Tampilkan/sembunyikan teks di belakang CW",
  "keyboard_shortcuts.toggle_sensitivity": "Tampilkan/sembunyikan media",
  "keyboard_shortcuts.toot": "Buat posting baru",
  "keyboard_shortcuts.unfocus": "Hapus fokus pada kotak teks/kotak pencarian",
  "keyboard_shortcuts.up": "Naik ke posisi atas dalam daftar",
  "lightbox.close": "Tutup",
  "lightbox.next": "Selanjutnya",
  "lightbox.previous": "Sebelumnya",
  "limited_account_hint.action": "Tetap tampilkan profil",
  "limited_account_hint.title": "Profil ini telah disembunyikan oleh moderator {domain}.",
  "link_preview.author": "Oleh {name}",
  "lists.delete": "Hapus daftar",
  "lists.edit": "Sunting daftar",
  "lists.replies_policy.followed": "Siapa pun pengguna yang diikuti",
  "lists.replies_policy.list": "Anggota di daftar tersebut",
  "lists.replies_policy.none": "Tidak ada satu pun",
  "load_pending": "{count, plural, other {# item baru}}",
  "loading_indicator.label": "Memuat…",
  "moved_to_account_banner.text": "Akun {disabledAccount} Anda kini dinonaktifkan karena Anda pindah ke {movedToAccount}.",
  "mute_modal.hide_options": "Sembunyikan opsi",
  "mute_modal.title": "Bisukan pengguna?",
  "navigation_bar.about": "Tentang",
  "navigation_bar.blocks": "Pengguna diblokir",
  "navigation_bar.bookmarks": "Markah",
  "navigation_bar.domain_blocks": "Domain tersembunyi",
  "navigation_bar.filters": "Kata yang dibisukan",
  "navigation_bar.follow_requests": "Permintaan mengikuti",
  "navigation_bar.followed_tags": "Tagar yang diikuti",
  "navigation_bar.follows_and_followers": "Ikuti dan pengikut",
  "navigation_bar.lists": "Daftar",
  "navigation_bar.logout": "Keluar",
  "navigation_bar.mutes": "Pengguna dibisukan",
  "navigation_bar.preferences": "Pengaturan",
  "navigation_bar.search": "Cari",
  "not_signed_in_indicator.not_signed_in": "Anda harus masuk untuk mengakses sumber daya ini.",
  "notification.admin.report": "{name} melaporkan {target}",
  "notification.admin.sign_up": "{name} mendaftar",
  "notification.follow": "{name} mengikuti Anda",
  "notification.follow_request": "{name} ingin mengikuti Anda",
  "notification.own_poll": "Japat Anda telah berakhir",
  "notification.reblog": "{name} mem-boost kiriman Anda",
  "notification.status": "{name} baru saja mengirim",
  "notification.update": "{name} mengedit kiriman",
  "notifications.clear": "Hapus notifikasi",
  "notifications.clear_confirmation": "Apa Anda yakin hendak menghapus semua notifikasi Anda?",
  "notifications.column_settings.admin.report": "Laporan baru:",
  "notifications.column_settings.admin.sign_up": "Pendaftaran baru:",
  "notifications.column_settings.alert": "Notifikasi desktop",
  "notifications.column_settings.follow": "Pengikut baru:",
  "notifications.column_settings.follow_request": "Permintaan mengikuti baru:",
  "notifications.column_settings.mention": "Balasan:",
  "notifications.column_settings.poll": "Hasil japat:",
  "notifications.column_settings.push": "Notifikasi dorong",
  "notifications.column_settings.reblog": "Boost:",
  "notifications.column_settings.show": "Tampilkan dalam kolom",
  "notifications.column_settings.sound": "Mainkan suara",
  "notifications.column_settings.status": "Kiriman baru:",
  "notifications.column_settings.unread_notifications.category": "Notifikasi yang belum dibaca",
  "notifications.column_settings.unread_notifications.highlight": "Sorot notifikasi yang belum dibaca",
  "notifications.column_settings.update": "Edit:",
  "notifications.filter.all": "Semua",
  "notifications.filter.boosts": "Boost",
  "notifications.filter.follows": "Diikuti",
  "notifications.filter.mentions": "Sebutan",
  "notifications.filter.polls": "Hasil japat",
  "notifications.filter.statuses": "Pembaruan dari orang yang Anda ikuti",
  "notifications.grant_permission": "Setujui izin.",
  "notifications.group": "{count} notifikasi",
  "notifications.mark_as_read": "Tandai setiap notifikasi sebagai sudah dibaca",
  "notifications.permission_denied": "Tidak dapat mengaktifkan notifikasi desktop karena izin ditolak.",
  "notifications.permission_denied_alert": "Notifikasi desktop tidak dapat diaktifkan karena izin peramban telah ditolak sebelumnya",
  "notifications.permission_required": "Notifikasi desktop tidak tersedia karena izin yang dibutuhkan belum disetujui.",
  "notifications_permission_banner.enable": "Aktifkan notifikasi desktop",
  "notifications_permission_banner.how_to_control": "Untuk menerima notifikasi saat Mastodon terbuka, aktifkan notifikasi desktop. Anda dapat mengendalikan tipe interaksi mana yang ditampilkan notifikasi desktop melalui tombol {icon} di atas saat sudah aktif.",
  "notifications_permission_banner.title": "Jangan lewatkan apa pun",
  "picture_in_picture.restore": "Taruh kembali",
  "poll.closed": "Ditutup",
  "poll.refresh": "Segarkan",
  "poll.reveal": "Lihat hasil",
  "poll.total_people": "{count, plural, other {# orang}}",
  "poll.total_votes": "{count, plural, other {# suara}}",
  "poll.vote": "Pilih",
  "poll.voted": "Anda memilih jawaban ini",
  "poll.votes": "{votes, plural, other {# suara}}",
  "poll_button.add_poll": "Tambah japat",
  "poll_button.remove_poll": "Hapus japat",
  "privacy.change": "Ubah privasi kiriman",
  "privacy.public.short": "Publik",
  "privacy_policy.last_updated": "Terakhir diperbarui {date}",
  "privacy_policy.title": "Kebijakan Privasi",
  "refresh": "Segarkan",
  "relative_time.days": "{number}h",
  "relative_time.full.days": "{number, plural, other {# hari}} yang lalu",
  "relative_time.full.hours": "{number, plural, other {# jam}} yang lalu",
  "relative_time.full.just_now": "baru saja",
  "relative_time.full.minutes": "{number, plural, other {# menit}} yang lalu",
  "relative_time.full.seconds": "{number, plural, other {# detik}} yang lalu",
  "relative_time.hours": "{number}j",
  "relative_time.just_now": "sekarang",
  "relative_time.minutes": "{number}m",
  "relative_time.seconds": "{number}d",
  "relative_time.today": "hari ini",
  "reply_indicator.cancel": "Batal",
  "report.block": "Blokir",
  "report.block_explanation": "Anda tidak akan melihat kiriman mereka. Mereka tidak akan bisa melihat kiriman Anda atau mengikuti Anda. Mereka akan mampu menduga bahwa mereka diblokir.",
  "report.categories.other": "Lainnya",
  "report.categories.spam": "Spam",
  "report.categories.violation": "Konten melanggar satu atau lebih peraturan server",
  "report.category.subtitle": "Pilih pasangan terbaik",
  "report.category.title": "Beritahu kami apa yang terjadi dengan {type} ini",
  "report.category.title_account": "profil",
  "report.category.title_status": "kiriman",
  "report.close": "Selesai",
  "report.comment.title": "Adakah hal lain yang perlu kami ketahui?",
  "report.forward": "Teruskan ke {target}",
  "report.forward_hint": "Akun dari server lain. Kirim salinan laporan scr anonim ke sana?",
  "report.mute": "Bisukan",
  "report.mute_explanation": "Anda tidak akan melihat kiriman mereka. Mereka masih dapat mengikuti Anda dan melihat kiriman Anda dan tidak akan mengetahui bahwa mereka dibisukan.",
  "report.next": "Selanjutnya",
  "report.placeholder": "Komentar tambahan",
  "report.reasons.dislike": "Saya tidak menyukainya",
  "report.reasons.dislike_description": "Ini bukan hal yang ingin Anda lihat",
  "report.reasons.other": "Itu sesuatu yang lain",
  "report.reasons.other_description": "Permasalahan ini tidak sesuai pada kategori lain",
  "report.reasons.spam": "Ini spam",
  "report.reasons.spam_description": "Tautan berbahaya, interaksi palsu, atau balasan berulang",
  "report.reasons.violation": "Melanggar ketentuan server",
  "report.reasons.violation_description": "Anda menyadari bahwa ia melanggar ketentuan tertentu",
  "report.rules.subtitle": "Pilih semua yang berlaku",
  "report.rules.title": "Ketentuan manakah yang dilanggar?",
  "report.statuses.subtitle": "Pilih semua yang berlaku",
  "report.statuses.title": "Adakah kiriman yang mendukung pelaporan ini?",
  "report.submit": "Kirim",
  "report.target": "Melaporkan {target}",
  "report.thanks.take_action": "Berikut adalah pilihan Anda untuk mengatur apa yang Anda lihat di Mastodon:",
  "report.thanks.take_action_actionable": "Ketika kami meninjau ini, Anda dapat mengambil tindakan terhadap @{name}:",
  "report.thanks.title": "Tidak ingin melihat ini?",
  "report.thanks.title_actionable": "Terima kasih atas pelaporan Anda, kami akan memeriksa ini lebih lanjut.",
  "report.unfollow": "Berhenti mengikuti @{name}",
  "report.unfollow_explanation": "Anda mengikuti akun ini. Untuk tidak melihat kiriman mereka di beranda Anda, berhenti mengikuti mereka.",
  "report_notification.attached_statuses": "{count, plural, other {{count} kiriman}} terlampir",
  "report_notification.categories.other": "Lainnya",
  "report_notification.categories.spam": "Spam",
  "report_notification.categories.violation": "Pelanggaran peraturan",
  "report_notification.open": "Buka laporan",
  "search.placeholder": "Pencarian",
  "search.quick_action.open_url": "Buka tautan di Mastodon",
  "search.search_or_paste": "Cari atau ketik URL",
  "search_results.all": "Semua",
  "search_results.hashtags": "Tagar",
  "search_results.statuses": "Kiriman",
  "server_banner.about_active_users": "Orang menggunakan server ini selama 30 hari terakhir (Pengguna Aktif Bulanan)",
  "server_banner.active_users": "pengguna aktif",
  "server_banner.administered_by": "Dikelola oleh:",
  "server_banner.server_stats": "Statistik server:",
  "sign_in_banner.create_account": "Buat akun",
  "sign_in_banner.sign_in": "Masuk",
  "status.admin_account": "Buka antarmuka moderasi untuk @{name}",
  "status.admin_domain": "Buka antarmuka moderasi untuk {domain}",
  "status.admin_status": "Buka kiriman ini dalam antar muka moderasi",
  "status.block": "Blokir @{name}",
  "status.bookmark": "Markah",
  "status.cancel_reblog_private": "Batalkan boost",
  "status.cannot_reblog": "Kiriman ini tak dapat di-boost",
  "status.copy": "Salin tautan ke kiriman",
  "status.delete": "Hapus",
  "status.detailed_status": "Tampilan detail percakapan",
  "status.edit": "Edit",
  "status.edited_x_times": "Diedit {count, plural, other {{count} kali}}",
  "status.filter": "Saring kiriman ini",
  "status.history.created": "{name} membuat {date}",
  "status.history.edited": "{name} mengedit {date}",
  "status.load_more": "Tampilkan semua",
  "status.media_hidden": "Media disembunyikan",
  "status.mention": "Sebutkan @{name}",
  "status.more": "Lebih banyak",
  "status.mute": "Bisukan @{name}",
  "status.mute_conversation": "Bisukan percakapan",
  "status.open": "Tampilkan kiriman ini",
  "status.pin": "Sematkan di profil",
  "status.read_more": "Baca lebih banyak",
  "status.reblog": "Boost",
  "status.reblogged_by": "{name} mem-boost",
  "status.reblogs.empty": "Belum ada yang mem-boost toot ini. Ketika seseorang melakukannya, mereka akan muncul di sini.",
  "status.redraft": "Hapus & draf ulang",
  "status.remove_bookmark": "Hapus markah",
  "status.replied_to": "Membalas ke {name}",
  "status.reply": "Balas",
  "status.replyAll": "Balas ke utasan",
  "status.report": "Laporkan @{name}",
  "status.sensitive_warning": "Konten sensitif",
  "status.share": "Bagikan",
  "status.show_less_all": "Tampilkan lebih sedikit untuk semua",
  "status.show_more_all": "Tampilkan lebih banyak untuk semua",
  "status.show_original": "Tampilkan yang asli",
  "status.title.with_attachments": "{user} posted {attachmentCount, plural, one {an attachment} other {# attachments}}",
  "status.translate": "Terjemahkan",
  "status.translated_from_with": "Diterjemahkan dari {lang} menggunakan {provider}",
  "status.unmute_conversation": "Bunyikan percakapan",
  "status.unpin": "Hapus sematan dari profil",
  "subscribed_languages.lead": "Hanya kiriman dalam bahasa yang dipilih akan muncul di linimasa beranda dan daftar setelah perubahan. Pilih tidak ada untuk menerima kiriman dalam semua bahasa.",
  "subscribed_languages.save": "Simpan perubahan",
  "subscribed_languages.target": "Ubah langganan bahasa untuk {target}",
  "tabs_bar.home": "Beranda",
  "tabs_bar.notifications": "Notifikasi",
  "time_remaining.days": "{number, plural, other {# hari}} tersisa",
  "time_remaining.hours": "{number, plural, other {# jam}} tersisa",
  "time_remaining.minutes": "{number, plural, other {# menit}} tersisa",
  "time_remaining.moments": "Momen tersisa",
  "time_remaining.seconds": "{number, plural, other {# detik}} tersisa",
  "trends.counter_by_accounts": "{count, plural, other {{counter} orang}} dalam {days, plural, other {{days} hari}} terakhir",
  "trends.trending_now": "Sedang tren sekarang",
  "ui.beforeunload": "Draf Anda akan hilang jika Anda keluar dari Mastodon.",
  "units.short.billion": "{count}M",
  "units.short.million": "{count}Jt",
  "units.short.thousand": "{count}rb",
  "upload_area.title": "Seret & lepaskan untuk mengunggah",
  "upload_button.label": "Tambahkan media",
  "upload_error.limit": "Batas unggah berkas terlampaui.",
  "upload_error.poll": "Unggah berkas tak diizinkan di japat ini.",
  "upload_form.edit": "Sunting",
  "upload_progress.label": "Mengunggah...",
  "upload_progress.processing": "Memproses…",
  "video.close": "Tutup video",
  "video.download": "Unduh berkas",
  "video.exit_fullscreen": "Keluar dari layar penuh",
  "video.expand": "Perbesar video",
  "video.fullscreen": "Layar penuh",
  "video.hide": "Sembunyikan video",
  "video.pause": "Jeda",
  "video.play": "Putar"
}
